import { render, staticRenderFns } from "./OtherIncomeExpenses.vue?vue&type=template&id=a2e1446c&"
import script from "./OtherIncomeExpenses.vue?vue&type=script&lang=js&"
export * from "./OtherIncomeExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports